import React from "react";
import { BadgeCheck } from "lucide-react";
import { LicenseLink } from "../LicenseLink";

export const MobileLicenseStrip = ({ t }) => (
  <LicenseLink
    t={t}
    testId="header-license-mobile"
    className="md:hidden bg-brand-primary text-white flex items-center justify-center gap-1.5 py-1.5 px-5 active:bg-brand-accent transition-colors"
  >
    <BadgeCheck className="w-3.5 h-3.5 text-brand-accent" strokeWidth={2.5} />
    <span className="font-display font-bold text-[11px] tracking-wide underline decoration-dotted underline-offset-2 decoration-white/50">
      {t.footer.licenseHeader}
    </span>
  </LicenseLink>
);
